
export interface NavigationState {
  returnUrl: string | null;
  returnSource: string;
  timestamp: number;
  preserveState: boolean;
  provider: string;
}

export interface ReturnOptions {
  showToast?: boolean;
  toastMessage?: string;
  additionalParams?: Record<string, string>;
  replace?: boolean;
  delay?: number;
}

export interface VezgoNavigationContextType {
  navigationState: NavigationState;
  setNavigationState: (state: Partial<NavigationState>) => void;
  saveCurrentLocation: (provider?: string, source?: string) => void;
  returnToPreviousLocation: (options?: ReturnOptions) => void;
  redirectToInvestments: (message?: string) => void;
  isReturningFromConnection: boolean;
  saveState: (state: string) => void;
  getState: () => string | null;
  saveProvider: (provider: string) => void;
  getProvider: () => string | null;
  detectReloadLoop: () => boolean;
  clearAllNavigationData: () => void;
  saveToStorage: (key: string, value: string) => boolean;
  getFromStorage: (key: string, defaultValue?: string | null) => string | null;
}

export const defaultNavigationState: NavigationState = {
  returnUrl: null,
  returnSource: 'unknown',
  timestamp: Date.now(),
  preserveState: false,
  provider: 'vezgodemo'
};
